/* eslint-disable max-len */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useState, useContext, useEffect } from 'react';
import Typography from '@digital-hig/mui/dist/Typography';
// import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import styled, { createGlobalStyle } from 'styled-components';
// eslint-disable-next-line import/no-extraneous-dependencies
import Grid from '@mui/material/Grid';
import IconButton from '@digital-hig/mui/dist/IconButton';
// eslint-disable-next-line import/no-extraneous-dependencies
import MUILink from '@mui/material/Link';
// eslint-disable-next-line import/no-extraneous-dependencies
import Icon from '@mui/material/SvgIcon';
import Back from '@digital-hig/icon/lib/esm/icons/back';
import Cross from '@digital-hig/icon/lib/esm/icons/cross';
import Checkmark from '@digital-hig/icon/lib/esm/icons/checkmark';
import Divider from '@mui/material/Divider';
import Accordion from '@digital-hig/mui/dist/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import CompleteIcon from '@digital-hig/icon/lib/esm/display-icons/complete';
import {
  ENVIRONMENT, PAGETYPE_MODULE_UNIT, PAGETYPE_COURSE_UNIT, PAGETYPE_TUTORIAL, PAGETYPE_COURSE_MODULE,
} from './constants';
import EnvContext from './envContext';
import OutlineUnits from './outlineUnits';
import { hasCompletedRecord } from './userUtils';
import { triggerManualLinkClick, formatString } from './analyticsApi';

const UnitDrawer = ({
  isOpen, openCloseCallback, data, tutorials, unitLookup, learningRecords, curUnitId, tutorialId, pageType,
}) => {
  const [curTutorial, setCurTutorial] = useState();
  const envContext = useContext(EnvContext);
  const env = envContext[ENVIRONMENT];

  useEffect(() => {
    // when unit pagination for course module body we have to filter with current modlue body as unit id wont be available
    const filterCurTutorial = tutorials?.filter((tutorial) => tutorialId === tutorial.id || tutorial?.units?.filter(((unit) => unit.id === curUnitId))[0]);
    // given time to open the accordion after open the drawer
    setTimeout(() => {
      setCurTutorial(filterCurTutorial[0]);
    }, 300);
  }, [tutorials, curUnitId, tutorialId]);

  const handleClose = () => {
    openCloseCallback(false);
  };

  const buildUnitData = ({ tutorial, moduleUnits }) => {
    const moduleOrCourseUnitData = tutorial ? tutorial.units : moduleUnits;
    const unitData = moduleOrCourseUnitData.map((unit) => ({
      id: unit.id,
      uri: `${data.uri}/unit/${unit.id}`,
      title: unitLookup[unit.id]?.title,
      isCompleted: hasCompletedRecord({ id: unit.id, learningRecords, env }),
    }));
    return unitData;
  };

  const renderTitleWithIcon = (curTutorialId, title) => {
    const isTutorialComplete = hasCompletedRecord({ id: curTutorialId, learningRecords, env });

    if (isTutorialComplete) {
      return (
        <>
          <Icon id="tutorial-complete" size="large">
            <CompleteIcon />
          </Icon>
          {title}
        </>
      );
    }
    return title;
  };

  return (
    <>
      <GlobalStyles />
      <RootElement onClick={handleClose}>
        <Grid container className="overlay">
          <Grid className={`${isOpen ? 'unit-drawer open' : 'unit-drawer close'}`} onClick={(e) => e.stopPropagation()}>
            <Grid container justifyContent="space-between" alignItems="center" rowSpacing={0}>
              <Grid item>
                <MUILink
                  underline="none"
                  component={Link}
                  to={data.uri}
                  style={{ 'text-decoration': 'none' }}
                >
                  <Icon size="medium">
                    <Back />
                  </Icon>
                  {pageType === PAGETYPE_MODULE_UNIT && 'Back to module overview'}
                  {(pageType === PAGETYPE_COURSE_UNIT || pageType === PAGETYPE_COURSE_MODULE) && 'Back to course overview'}
                  {pageType === PAGETYPE_TUTORIAL && 'Back to list page'}
                </MUILink>
              </Grid>
              <Grid item>
                <IconButton variant="text" data-testid="close-drawer-btn" onClick={handleClose}>
                  <Icon size="medium">
                    <Cross />
                  </Icon>
                </IconButton>
              </Grid>
            </Grid>

            <Divider flexItem orientation="horizontal" sx={{ my: '16px' }} />

            <Grid container item>
              <Grid>
                <Typography component="h3" variant="headline-small">{data.title}</Typography>
              </Grid>
            </Grid>
            {pageType === PAGETYPE_MODULE_UNIT
            && (
              <Grid container item>
                <Grid item>
                  <OutlineUnits units={buildUnitData({ moduleUnits: data.units })} curUnitId={curUnitId} analyticsPrefix={`module navigation flyout:na:na:${formatString(data?.title)}:${tutorialId}:`} />
                </Grid>
              </Grid>
            )}
            {(pageType === PAGETYPE_COURSE_UNIT || pageType === PAGETYPE_COURSE_MODULE) && (
              <Grid container item>
                <Grid item>
                  {tutorials.map((tutorial) => (
                    <Accordion id={`accordion-${tutorial.id}`} expanded={curTutorial?.id === tutorial.id} onChange={() => (curTutorial === tutorial ? setCurTutorial('') : setCurTutorial(tutorial))} variant="individualPanel">
                      <AccordionSummary>
                        <Typography data-testid="module-title" variant="headline-smaller">{renderTitleWithIcon(tutorial.id, tutorial.title)}</Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Typography variant="short-copy-small">
                          <MUILink
                            underline="none"
                            component={Link}
                            onClick={() => { triggerManualLinkClick({ linkTitle: `module overview:${tutorial.id}` }); }}
                            to={`${data.uri}/module/${tutorial.id}`}
                            className="overview-link"
                          >
                            Module overview
                          </MUILink>
                        </Typography>
                        <OutlineUnits units={buildUnitData({ tutorial })} curUnitId={curUnitId} analyticsPrefix={`course navigation flyout:${formatString(data?.title)}:${data?.id}:${formatString(tutorial?.title)}:${tutorial?.id}:`} />
                      </AccordionDetails>
                    </Accordion>
                  ))}
                </Grid>
              </Grid>
            )}
            {pageType === PAGETYPE_TUTORIAL
            && (
              <Grid component="ul" className="tutorial-list">
                {tutorials?.map((tutorial) => (

                  <Typography component="li" color="text-link-loud-pressed">
                    <MUILink underline="none" component={Link} to={`${data.uri}/${tutorial.id}`} className={tutorial.id === tutorialId ? 'current-unit' : ''}>
                      {tutorial.title}
                      {tutorial.id === tutorialId && (
                        <Icon size="small">
                          <Checkmark />
                        </Icon>
                      )}
                    </MUILink>
                  </Typography>
                ))}
              </Grid>
            )}
          </Grid>
        </Grid>
      </RootElement>
    </>
  );
};

const GlobalStyles = createGlobalStyle`
  // overriding global header z-index when drawer opens
  .uh-container-wrapper .uh-pn-container .uh-pn-component ul {
    z-index: unset !important;
  }
`;

const RootElement = styled.div`
.MuiGrid-root.MuiGrid-item{
  padding-left: 0;
}
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9999;

  #tutorial-complete {
    width: 35px;
    height: 35px;
    margin-right: 6px;
  }
  .unit-drawer {
    width: 30vw;
    height: 100vh;
    padding: 16px 32px 24px 68px;
    background: #f9f9f9;
    position: absolute;
    top: 0;
    left: -30vw;
    overflow: auto;

  }
  .overview-link {
    display: flex;
    padding: 0 0 20px 0;
  }
  .unit-drawer.open {
    animation-name: move;
    animation-fill-mode: both;
    animation-timing-function: ease-out;
    animation-duration: 0.2s;
  }

  .unit-drawer.close {
    animation-name: close;
    animation-fill-mode: both;
    animation-timing-function: ease-out;
    animation-duration: 0.2s;
  }
  .DhigAccordion--variant--individualPanel.Mui-expanded{
    box-shadow: none;
    border: 2px solid #000;
  }

  ul.tutorial-list {
    list-style: none;
    margin-left: -20px;
    padding: 0;
    li {
      a {
        padding: 9px 12px 10px 20px;
        display: flex;
      }
      a.current-unit{
        background-color: rgba(0, 0, 0, 0.04);
        display: flex;
        align-items: center;
        margin: 6px 0;
        justify-content: space-between;

        svg {
          margin-left: 8px;
        }
      }
    }
  }
  @keyframes move {
    100%{
        left: 0;
    }
  }

  @keyframes close {
    100%{
        left: -30vw;
    }
  }

  @media screen and (max-width: 559px) {
    .unit-drawer {
      width: 85vw;
    }
  }

  @media screen and (min-width: 560px) and (max-width: 1039px) {
    .unit-drawer {
      width: 50vw;
    }
  }
`;

UnitDrawer.propTypes = {
  pageType: PropTypes.string,
  isOpen: PropTypes.string.isRequired,
  openCloseCallback: PropTypes.func.isRequired,
  data: PropTypes.shape({
    title: PropTypes.string,
    uri: PropTypes.string,
    units: PropTypes.string,
    id: PropTypes.string,
  }),
  tutorials: PropTypes.arrayOf({}),
  unitLookup: PropTypes.shape({}),
  learningRecords: PropTypes.shape({}),
  curUnitId: PropTypes.string,
  tutorialId: PropTypes.string,
};

UnitDrawer.defaultProps = {
  pageType: '',
  data: {},
  tutorials: [],
  unitLookup: {},
  learningRecords: {},
  curUnitId: '',
  tutorialId: '',
};

export default React.memo(UnitDrawer);
